import React from 'react';
import { Text, ProgressBar, Checkbox, DatePicker } from '../../Atoms';
import { Input, AffiliationRecapMolecule, AffiliationButtonMolecule } from '../../Molecules';
import { Row, Col } from 'react-bootstrap';
import { ModalPdf } from '../../Modals';
import Test from "../../assets/pdf/test.pdf"

function OrganismAffiliationStage1(props) {
    const [show, setShow] = React.useState(false)
    return (
        <div className="organism-affilation-stage1-container">
            <ModalPdf
                show={show}
                onHide={() => setShow(false)}
                url={Test}
            />
            <Text text="Complétez votre affiliation" className="organism-affiliation-stage1-title" />
            <Text text="Afin de finaliser votre adhésion, merci de bien vouloir remplir les champs suivants :" className="organism-affiliation-stage1-description" />
            <Text text={`Etape ${props.stage} / 5`} className="organism-affiliation-stage1-stage" />
            <ProgressBar
                percent={`${(props.stage * 100 / 5).toString()}%`}
                height="15px"
                backgroundColor="#fff"
                backgroundColorFulFilled="#FF8AD8"
                containerClassName="organism-affiliation-stage1-progressBar"
            />
            <div >
                <div className="organism-affiliation-stage1-recap-container">
                    <AffiliationRecapMolecule />
                </div>
                <div className="organism-affiliation-form-container">
                    <Text text="Informations personnelles" className="organism-affiliation-stage1-personal-info" />
                    <Row className="organism-affiliation-stage1-row" >
                        <Col lg={2} xs={12} className="organism-affiliation-stage1-col">
                            <Text text="Civilité" className="organism-affiliation-stage1-input-label" />
                            <div className="organism-affiliation-stage1-checkBox-container" >
                                <Checkbox
                                    type="checkbox"
                                    classNameContainer="organism-affiliation-checkbox-container"
                                    label="Mme"
                                    className="organism-affiliation-stage1-checkbox"
                                    size={13}
                                    onClick={(e) => props.checkBoxClicked(e.target.textContent)}
                                    checked={props.check == 'Mme'}
                                />
                                <Checkbox
                                    type="checkbox"
                                    classNameContainer="organism-affiliation-checkbox-container"
                                    label="M"
                                    className="organism-affiliation-stage1-checkbox"
                                    size={13}
                                    onClick={(e) => props.checkBoxClicked(e.target.textContent)}
                                    checked={props.check == 'M'}
                                />
                            </div>

                        </Col>
                        <Col lg={4} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                inputLabel="Nom"
                                placeholder=""
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'firstName')}
                                value={props.data.firstName}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col">
                            <Input
                                inputLabel="Prénom"
                                placeholder=""
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'lastName')}
                                value={props.data.lastName}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Text text="Date de naissance" className="organism-affiliation-stage1-input-label" />
                            <DatePicker
                                placeholder="JJ/MM/AAAA"
                                renderIcon={false}
                                containerClassName="organism-affiliation-stage1-input-container"
                                className="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e, 'date')}
                                selected={props.data.date}
                            />
                        </Col>

                        <Col lg={4} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Situation familiale"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                optionsClassName="organism-affiliation-stage1-input-label organism-affiliation-stage1-option-input"
                                as="select"
                                options={[
                                    {
                                        text: "Célibataire",
                                        value: "Célibataire"
                                    },
                                    {
                                        text: "Marié(e)",
                                        value: "Marié(e)"
                                    },
                                    {
                                        text: "Veuf(ve)",
                                        value: "Veuf(ve)"
                                    },
                                    {
                                        text: "Divorcé(e)",
                                        value: "Divorcé(e)"
                                    },
                                    {
                                        text: "Séparé(e) de corps judiciairement",
                                        value: "Séparé(e) de corps judiciairement"
                                    },
                                    {
                                        text: "Concubin(e)",
                                        value: "Concubin(e)"
                                    },
                                    {
                                        text: "Pacsé(e)",
                                        value: "Pacsé(e)"
                                    },
                                ]}
                                onChange={(e) => props.inputChange(e, 'familySituation')}
                                value={props.data.familySituation}
                                optionContainerClassName="organism-affiliation-stage1-option-selected"
                            />
                        </Col>
                        <Col lg={4} xs={6} sm={6} className="organism-affiliation-stage1-col">
                            <Input
                                placeholder=""
                                inputLabel="Numéro de sécurité sociale"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'securityNumber')}
                                value={props.data.securityNumber}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Organisme de rattachement"
                                icon="QuestionMark"
                                iconSize="15px"
                                iconClassName="organism-affiliation-stage1-question-mark-icon cursor"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'rattachement')}
                                value={props.data.rattachement}
                                onClickIcon={() => setShow(true)}
                            />
                        </Col>

                        <Col lg={5} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Adresse mail personnelle"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'mail')}
                                value={props.data.mail}
                            />
                        </Col>
                        <Col lg={3} xs={6} sm={6} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Téléphone mobile"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'phoneNumber')}
                                value={props.data.phoneNumber}
                            />
                        </Col>

                        <Col lg={6} xs={12} sm={12} className="organism-affiliation-stage1-col" >
                            <Input
                                placeholder=""
                                inputLabel="Adresse postale"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'postalAdress')}
                                value={props.data.postalAdress}
                            />
                        </Col>
                        <Col lg={6} xs={12} sm={12} className="organism-affiliation-stage1-col organism-affiliation-stage1-col-address" >
                            <Text
                                text="Saisir l’adresse manuellement"
                                labelClassName="organism-affiliation-stage1-input-label"
                                classNameInputContainer="organism-affiliation-stage1-input-container"
                                onChange={(e) => props.inputChange(e.target.value, 'address')}
                                value={props.data.address}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
            <AffiliationButtonMolecule
                confirmerClicked={props.confirmerClicked}
                goBackClicked={props.goBackClicked}
            />
        </div>
    );
}

export default OrganismAffiliationStage1;
